import { ItemCardDetails } from "@/components/ItemCard";
import { type ServiceWorkOrderData } from "@repo/api/src/opportunity/types";
import { Badge, LightMode, Variables } from "@repo/skapa";
import { t } from "@repo/translation";
import { FlexDiv, LocalizedDateAndTime, SimpleLabelField } from "@repo/ui";

interface WorkOrderDetailsProps {
  workOrder: ServiceWorkOrderData;
}

export const WorkOrderDetails = ({ workOrder }: WorkOrderDetailsProps) => {
  const title = workOrder.workOrderNumber
    ? `${t("label.work_order")} ${workOrder.workOrderNumber}`
    : t("label.work_order");

  const description = `${t("label.work_type")}: ${workOrder.workType ?? "-"}`;

  const scheduledStartField = (
    <SimpleLabelField
      small
      label={t("label.scheduled_start_date")}
      value={
        workOrder.scheduledStartTime ? (
          <LocalizedDateAndTime date={workOrder.scheduledStartTime} />
        ) : (
          "-"
        )
      }
      color={LightMode.colourTextAndIcon2}
    />
  );

  const scheduledEndField = (
    <SimpleLabelField
      small
      label={t("label.scheduled_end_date")}
      value={
        workOrder.scheduledEndTime ? (
          <LocalizedDateAndTime date={workOrder.scheduledEndTime} />
        ) : (
          "-"
        )
      }
      color={LightMode.colourTextAndIcon2}
    />
  );

  return (
    <ItemCardDetails
      title={title}
      description={description}
      addOn={
        <div>
          <FlexDiv margin={`0 0 ${Variables.space25}`}>
            <Badge label={workOrder.status} size="small" />
          </FlexDiv>
          {scheduledStartField}
          {scheduledEndField}
        </div>
      }
    />
  );
};
